import React from 'react';
import { YoutubeShortsBlockType } from '@appTypes/YoutubeShortsBlockType';
import { ShortsCarousel } from '@components/ShortsCarousel/ShortsCarousel';

type ShortsCarouselBlockProps = {
  block: YoutubeShortsBlockType;
};

export const ShortsCarouselBlock = ({ block }: ShortsCarouselBlockProps) => (
  <ShortsCarousel videos={block.videos} title={block.title} background={block.background} />
);
